module.exports = __webpack_public_path__ + "static/narrowTexture-77159d756053ee5ff0fba3c65b046a80.png";